export class EmbedError extends Error {
    code;
    constructor(message, code) {
        super(message);
        this.code = code;
        this.name = 'EmbedError';
    }
}
//# sourceMappingURL=types.js.map